import React from 'react';
import MovieList from '../components/organisms/MoviesList';

function ListOfMovies() {
  return <MovieList />;
}

export default ListOfMovies;
